import { render, staticRenderFns } from "./assignee_avatar_link.vue.js?vue&type=template&id=dbb0b798&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./assignee_avatar_link.vue?vue&type=template&id=dbb0b798&vue3"
import script from "./assignee_avatar_link.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./assignee_avatar_link.vue?vue&type=script&lang=js&vue3"
export * from "./assignee_avatar_link.vue.js?vue&type=script&lang=js&vue3!=!../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./assignee_avatar_link.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports